import { Grid, Typography } from '@mui/material';
import { ProceedSaveLater, SubHeading } from './components';
import { Formik, FormikHelpers, validateYupSchema, yupToFormErrors } from 'formik';
import MFSelectField from '../../lib/formik/SelectField';
import UseRadioGroup from '../../lib/formik/Radio';
import { MFTextField } from '../../lib/formik';
import {
  Applicant,
  tinCountriesList,
  tinValidateResponse,
} from '../../redux-store/types/api-types';
import {
  addressTypesMasters,
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  USER_ROLES,
} from '../../utils/constant';
import {
  applicationComparison,
  applyRoleBasedStatus,
  checkValidationBasedOnDate,
  getApplicantName,
  getCountryBasedOnStatus,
  getCurrentStep,
  navigateToNextStep,
  removeSingleQuote,
  saveForLater,
} from '../../utils/utilityFunctions';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { useHistory, useLocation } from 'react-router';
import { updateApplication } from '../../redux-store/actions/application';
import { FATCAValidationSchema } from '../../utils/schema';
import { Notes } from './components';
import { useSnackbar } from 'notistack';
import { mdmsCountriesList, nationaliyType } from '../../redux-store/types/mdms';
import { getNationalityList } from '../../redux-store/actions';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { useFeatureToggles, useMdmsCountryData } from '../../utils/useDataMdms';
import { getTinCountriesList, validateTin } from '../../redux-store/actions/onBoarding';
import { LoadingButton } from '@mui/lab';
import { InfoOutlined } from '@mui/icons-material';
import { showError } from '../../redux-store/actions/auth';

export type Values = {
  applicants: Partial<Applicant>[];
  saveType: string;
  countryDropdown: mdmsCountriesList[];
};

const initialValues: Values = {
  applicants: [
    {
      typeOfAddressProvidedAtKRA: '',
      taxResidentOfAnyCountryOtherThanIndia: false,
      placeOfBirth: '',
      countryOfBirth: 'INDIA',
      countryOfNationality: 'INDIA',
      taxCountryName: '',
      taxID: '',
      idType: '',
      nameOfEntity: '',
      dateOfIncorporation: '',
      cityOfIncorporation: '',
      countryOfIncorporation: '',
      entityExcemptionCode: '',
      statusSubType: '',
      isTinVerified: [null],
      tinExists: false,
      id: 1,
    },
  ],
  saveType: 'save and proceed',
  countryDropdown: [],
};

const FatcaDetails = ({
  applicantName,
  index,
  values,
  nationalitiesMdmsResponse,
  createdAt,
  tinCountries,
  formvalues,
  setValues,
}: {
  applicantName: string;
  index: number;
  values: Partial<Applicant>;
  nationalitiesMdmsResponse: mdmsCountriesList[];
  createdAt: string;
  tinCountries: tinCountriesList[];
  formvalues: Values;
  setValues: FormikHelpers<Values>['setValues'];
}): JSX.Element => {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const isFieldDisabled = [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role);
  const { application } = useSelector((store: RootStateType) => store.application);
  const [loading, setLoading] = useState(false);
  const { toggler } = useFeatureToggles();
  const { tin_declaration_validation_date = '' } = toggler?.dateFeatureToggles || {};
  const dispatch = useDispatch();
  const validateTinForApplicant = async () => {
    try {
      setLoading(true);
      if (values?.taxCountryName && values?.taxID) {
        const CountryCode = tinCountries?.find(
          (country) => country.countryName === values?.taxCountryName
        )?.countryCode;
        const res = (await dispatch(
          validateTin({
            TINFormat: 'Individuals',
            TINNo: values?.taxID,
            CountryCode: (CountryCode as string) || '',
            IdTypeCode: 'T',
            applicantId: formvalues?.applicants[index]?.id?.toString() || '',
          })
        )) as unknown as tinValidateResponse;

        setValues({
          ...formvalues,
          applicants: formvalues?.applicants?.map((applicant, ind) => {
            if (index === ind) {
              return {
                ...applicant,
                isTinVerified: [res?.isTinVerified],
              };
            }
            return applicant;
          }),
        });
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setLoading(false);
    }
  };
  // console.log(
  //   checkValidationBasedOnDate(application?.createdAt || '', tin_declaration_validation_date)
  // );
  // console.log(tin_declaration_validation_date, 'date');
  // console.log(toggler.dateFeatureToggles.fatca_validation_date, 'fatca');
  // console.log(application?.createdAt);
  return (
    <>
      <SubHeading>FATCA Details of {applicantName} Applicant</SubHeading>
      <Grid item xs={12} sm={6}>
        <MFSelectField
          name={`applicants.${index}.typeOfAddressProvidedAtKRA`}
          label="Type of Address Provided At KRA *"
          items={addressTypesMasters.map((address) => ({ key: address, value: address }))}
        />
      </Grid>
      <Grid item xs={12}>
        <UseRadioGroup
          formLabel="Tax Resident of any country other than India *"
          name={`applicants.${index}.taxResidentOfAnyCountryOtherThanIndia`}
          items={[
            { label: 'Yes', value: 'true' },
            { label: 'No', value: 'false' },
          ]}
          value={values.taxResidentOfAnyCountryOtherThanIndia?.toString()}
          disabled={isFieldDisabled}
        />
      </Grid>
      {/* {applicant?.taxResidentOfAnyCountryOtherThanIndia?.toString() === 'true' && ( */}
      <>
        <Grid item xs={12} sm={6}>
          <MFTextField
            name={`applicants.${index}.placeOfBirth`}
            label="Place of Birth *"
            placeholder="Enter Place of Birth"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          {/* <MFTextField
            name={`applicants.${index}.countryOfBirth`}
            label="Country of Birth *"
            placeholder="Enter Country of Birth"
            disabled={isFieldDisabled}
          /> */}
          <SearchableSelect
            name={`applicants.${index}.countryOfBirth`}
            label="Country of Birth *"
            items={nationalitiesMdmsResponse.map((nationality) => ({
              key: nationality.name,
              value: nationality.name,
            }))}
            disabled={isFieldDisabled}
            searchFieldPlaceholder={'Search Country'}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          {/* <MFTextField
            name={`applicants.${index}.countryOfNationality`}
            label="Country of Nationality *"
            placeholder="Enter Country of Nationality"
            disabled={isFieldDisabled}
          /> */}
          <SearchableSelect
            name={`applicants.${index}.countryOfNationality`}
            label="Country of Nationality *"
            items={getCountryBasedOnStatus(
              nationalitiesMdmsResponse,
              application?.applicants[index].statusSubType as string
            ).map((nationality) => ({
              key: nationality.name,
              value: nationality.name,
            }))}
            disabled={isFieldDisabled}
            searchFieldPlaceholder={'Search Country'}
          />
        </Grid>
        {values?.taxResidentOfAnyCountryOtherThanIndia?.toString() === 'true' && (
          <>
            <Grid item xs={12} sm={6}>
              <SearchableSelect
                name={`applicants.${index}.taxCountryName`}
                label="Tax country Name *"
                items={tinCountries
                  .filter((e) => e.countryName?.toLowerCase() !== 'india')
                  .map((nationality) => ({
                    key: nationality.countryName,
                    value: nationality.countryName,
                  }))}
                searchFieldPlaceholder={'Search Tax Country'}
                disabled={isFieldDisabled}
                onChange={({ target: { value } }) => {
                  setValues({
                    ...formvalues,
                    applicants: formvalues?.applicants?.map((applicant, ind) => {
                      if (index === ind) {
                        return {
                          ...applicant,
                          taxCountryName: value as string,
                          isTinVerified: [null],
                        };
                      }
                      return applicant;
                    }),
                  });
                }}
              />
            </Grid>
            {((checkValidationBasedOnDate(
              application?.createdAt || '',
              tin_declaration_validation_date
            ) &&
              !values?.tinExists) ||
              !checkValidationBasedOnDate(
                application?.createdAt || '',
                tin_declaration_validation_date
              )) && (
              <>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.taxID`}
                    label="Tax ID *"
                    placeholder="Enter Tax ID"
                    disabled={isFieldDisabled}
                    onChange={({ target: { value } }) => {
                      setValues({
                        ...formvalues,
                        applicants: formvalues?.applicants?.map((applicant, ind) => {
                          if (index === ind) {
                            return {
                              ...applicant,
                              taxID: value,
                              isTinVerified: [null],
                            };
                          }
                          return applicant;
                        }),
                      });
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.idType`}
                    label="ID Type *"
                    placeholder="Enter ID Type"
                    disabled={
                      isFieldDisabled ||
                      checkValidationBasedOnDate(
                        application?.createdAt || '',
                        tin_declaration_validation_date
                      )
                    }
                    onChange={({ target: { value } }) => {
                      setValues({
                        ...formvalues,
                        applicants: formvalues?.applicants?.map((applicant, ind) => {
                          if (index === ind) {
                            return {
                              ...applicant,
                              idType: value,
                              isTinVerified: [null],
                            };
                          }
                          return applicant;
                        }),
                      });
                    }}
                  />
                </Grid>
              </>
            )}
            {checkValidationBasedOnDate(
              application?.createdAt || '',
              tin_declaration_validation_date
            ) && (
              // !values?.tinExists &&
              <Grid
                item
                xs={12}
                display="flex"
                justifyContent="space-between"
                sx={{
                  width: '100%',
                  flexDirection: { xs: 'column-reverse', sm: 'row' },
                  alignItems: { xs: 'flex-start', sm: 'center' },
                }}>
                <Grid
                  xs={12}
                  sm={6}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}>
                  <LoadingButton
                    loadingPosition="end"
                    loading={loading}
                    disabled={
                      [true, false].includes(
                        (values?.isTinVerified?.length
                          ? values?.isTinVerified[0]
                          : false) as boolean
                      ) || loading
                    }
                    variant="contained"
                    sx={{ fontWeight: 500, fontSize: 14, width: '100%' }}
                    onClick={() => validateTinForApplicant()}>
                    Verify Tin
                  </LoadingButton>
                </Grid>
                {values.isTinVerified && values?.isTinVerified[0] !== null && (
                  <Grid
                    sm={6}
                    xs={12}
                    sx={{ position: 'relative', bottom: 10, mb: { xs: 2, sm: 0 } }}>
                    <Typography
                      component="div"
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        padding: { xs: 0, sm: '10px 20px' },
                        borderRadius: '5px',
                        alignItems: 'flex-start',
                        mt: 2,
                        width: '100%',
                        boxSizing: 'border-box',
                      }}>
                      <InfoOutlined color="info" fontSize="small" />
                      <Typography
                        sx={{
                          color: 'rgba(41, 49, 57, 0.7)',
                          fontSize: '13px',
                          fontWeight: 500,
                          ml: 1,
                        }}>
                        {values.isTinVerified && values?.isTinVerified[0] === true
                          ? 'Tin verified successfully'
                          : values.isTinVerified && values?.isTinVerified[0] === false
                          ? 'Tin verification failed'
                          : ''}
                      </Typography>
                    </Typography>
                  </Grid>
                )}
              </Grid>
            )}
          </>
        )}
        {/* <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.nameOfEntity`}
              label="Name of Entity"
              placeholder="Enter Name of Entity"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DatePicker
              label="Date of Incorporation"
              inputLabelStyles={{
                transform: 'unset',
                fontSize: 14,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)',
              }}
              maxDate={minDateForContributor()}
              name={`applicants.${index}.dateOfIncorporation`}
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              value={applicant.dateOfBirth || minDateForContributor().toString()}
              onChange={(newValue) => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant, ind) => {
                    if (index === ind) {
                      return {
                        ...applicant,
                        dateOfIncorporation: newValue?.toString(),
                      };
                    }
                    return applicant;
                  }),
                });
              }}
              textFieldStyles={{
                'label + &': {
                  mt: 4,
                },
                '& .MuiInputBase-root': {
                  border: '1px solid #DDEAF3',
                },
                '& .MuiOutlinedInput-root': {
                  position: 'relative',
                  backgroundColor: 'common.white',
                  border: '1px solid #DDEAF3',
                  fontSize: 16,
                  '&:hover': {
                    borderColor: 'primary.main',
                    '.MuiOutlinedInput-notchedOutline': {
                      border: 0,
                    },
                  },
                  '.MuiOutlinedInput-notchedOutline': {
                    border: 0,
                  },
                  '.MuiInputBase-input': {
                    p: '10px 12px',
                  },
                  '&:focus-visible': {
                    outline: 'none',
                  },
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.cityOfIncorporation`}
              label="City of Incorporation"
              placeholder="Enter City of Incorporation"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.countryOfIncorporation`}
              label="Country of Incorporation"
              placeholder="Enter Country of Incorporation"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.entityExcemptionCode`}
              label="Entity Exemption Code"
              placeholder="Enter Entity Exemption Code"
            />
          </Grid> */}
      </>
      {/* )} */}
    </>
  );
};

export default function Fatca(): JSX.Element {
  const [fatcaDetails, setFatcaDetails] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [tinCountries, setTinCountries] = useState<tinCountriesList[]>([]);
  const { toggler } = useFeatureToggles();
  const { tin_declaration_validation_date = '' } = toggler?.dateFeatureToggles || {};
  const [mdmsCountriesList, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);
  const { countries } = useMdmsCountryData();
  useEffect(() => {
    (async function () {
      try {
        const response = (await dispatch(getTinCountriesList())) as unknown as tinCountriesList[];
        setTinCountries(response);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);
  const location = useLocation();
  const path = location.pathname;
  useEffect(() => {
    (async function () {
      try {
        setMdmsCountriesList(countries.countries);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [countries]);

  useEffect(() => {
    const { applicants = [] } = application || {};
    (async function () {
      try {
        setFatcaDetails({
          ...fatcaDetails,
          applicants: applicants?.map((applicant) => ({
            id: applicant.id,
            typeOfAddressProvidedAtKRA: applicant.typeOfAddressProvidedAtKRA || '',
            taxResidentOfAnyCountryOtherThanIndia:
              applicant.taxResidentOfAnyCountryOtherThanIndia || false,
            placeOfBirth: applicant.placeOfBirth || '',
            countryOfBirth: applicant.countryOfBirth
              ? applicant.countryOfBirth.toUpperCase()
              : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)
              ? ''
              : 'INDIA',
            countryOfNationality: applicant.countryOfNationality
              ? applicant.countryOfNationality.toUpperCase()
              : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)
              ? ''
              : 'INDIA',
            taxCountryName: applicant.taxCountryName || '',
            taxID: applicant.taxID || '',
            idType:
              applicant.idType ||
              checkValidationBasedOnDate(
                application?.createdAt || '',
                tin_declaration_validation_date
              )
                ? 'TIN'
                : '',
            nameOfEntity: applicant.nameOfEntity || '',
            dateOfIncorporation: applicant.dateOfIncorporation || '',
            cityOfIncorporation: applicant.cityOfIncorporation || '',
            countryOfIncorporation: applicant.countryOfIncorporation || '',
            entityExcemptionCode: applicant.entityExcemptionCode || '',
            statusSubType: applicant.statusSubType || '',
            isTinVerified: [applicant.isTinVerified ? applicant.isTinVerified[0] : null],
            tinExists: applicant.tinExists || false,
          })),
          countryDropdown: mdmsCountriesList,
        });
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [application, mdmsCountriesList, tin_declaration_validation_date]);

  const handleSubmit = async (values: Values) => {
    try {
      const {
        applicants: existingApplicants = [],
        id,
        applicant1ReferenceId = '',
        currentStep,
        status,
        hasPOA,
        applicationNumber,
        createdAt,
      } = application || {};
      const { applicants, saveType } = values;
      applicants?.map((applicant, index) => {
        if (
          (applicant?.taxResidentOfAnyCountryOtherThanIndia || '')?.toString() === 'true' &&
          !applicant.tinExists &&
          checkValidationBasedOnDate(
            application?.createdAt || '',
            tin_declaration_validation_date
          ) &&
          (applicant?.isTinVerified ? applicant?.isTinVerified[0] : null) === null
        ) {
          throw `Tin Verification is mandatory for Applicant ${index + 1}`;
        }
      });
      const updatedPayload = existingApplicants.map((applicant, index: number) => {
        const {
          taxResidentOfAnyCountryOtherThanIndia = false,
          // dateOfBirth = '',
          dateOfIncorporation = '',
          ...rest
        } = applicants[index];
        return {
          ...applicant,
          taxResidentOfAnyCountryOtherThanIndia:
            taxResidentOfAnyCountryOtherThanIndia.toString() === 'false' ? false : true,
          // dateOfBirth: dateOfBirth ? dateOfBirth : null,
          dateOfIncorporation: dateOfIncorporation ? dateOfIncorporation : null,
          ...rest,
          placeOfBirth: removeSingleQuote(rest.placeOfBirth),
          taxCountryName:
            taxResidentOfAnyCountryOtherThanIndia.toString() === 'false'
              ? ''
              : removeSingleQuote(rest.taxCountryName),
          // taxID:
          //   taxResidentOfAnyCountryOtherThanIndia.toString() === 'false'
          //     ? ''
          //     : removeSingleQuote(rest.taxID),
          // idType:
          //   taxResidentOfAnyCountryOtherThanIndia.toString() === 'false'
          //     ? ''
          //     : removeSingleQuote(rest.idType),
          statusSubType: applicant.statusSubType || null,
          taxID: (
            checkValidationBasedOnDate(
              application?.createdAt || '',
              tin_declaration_validation_date
            )
              ? taxResidentOfAnyCountryOtherThanIndia.toString() === 'false' || rest.tinExists
              : taxResidentOfAnyCountryOtherThanIndia.toString() === 'false'
          )
            ? ''
            : removeSingleQuote(rest.taxID),
          idType: (
            checkValidationBasedOnDate(
              application?.createdAt || '',
              tin_declaration_validation_date
            )
              ? taxResidentOfAnyCountryOtherThanIndia.toString() === 'false' || rest.tinExists
              : taxResidentOfAnyCountryOtherThanIndia.toString() === 'false'
          )
            ? ''
            : removeSingleQuote(rest.idType),
          tinExists: !checkValidationBasedOnDate(
            application?.createdAt || '',
            tin_declaration_validation_date
          )
            ? null
            : rest.tinExists,
          isTinVerified: [
            (
              checkValidationBasedOnDate(
                application?.createdAt || '',
                tin_declaration_validation_date
              )
                ? taxResidentOfAnyCountryOtherThanIndia.toString() === 'false' || rest.tinExists
                : taxResidentOfAnyCountryOtherThanIndia.toString() === 'false'
            )
              ? null
              : rest.isTinVerified
              ? rest.isTinVerified[0]
              : null,
          ],
        };
      });
      const isSaveLater = saveType !== 'save and proceed';
      const checkApplication = applicationComparison(application, {
        ...application,
        applicants: updatedPayload,
        // currentStep: !!currentStep && currentStep > 4 ? currentStep : Number(currentStep) + 1,
        currentStep:
          !!currentStep &&
          currentStep >
            getCurrentStep(
              application?.applicationType || '',
              path,
              false,
              isSaveLater,
              application?.createdAt,
              toggler
            ) -
              1
            ? currentStep
            : getCurrentStep(
                application?.applicationType || '',
                path,
                false,
                isSaveLater,
                application?.createdAt,
                toggler
              ),
      });
      if (id && !checkApplication) {
        setLoading(true);
        await dispatch(
          updateApplication({
            body: {
              ...application,
              applicants: updatedPayload,
              status:
                !hasPOA &&
                AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                status !== 'draft' &&
                applyRoleBasedStatus(role)
                  ? 'sent_to_amc_approver'
                  : status,
              currentStep: getCurrentStep(
                application?.applicationType || '',
                path,
                false,
                isSaveLater,
                application?.createdAt,
                toggler
              ),
              //!!currentStep && currentStep > 4 ? currentStep : Number(currentStep) + 1,
            },
            applicationId: id,
            ...(isSaveLater && { toastMessage: '' }),
          })
        );
        history.push(
          navigateToNextStep(
            path,
            role,
            id || '',
            isSaveLater,
            applicant1ReferenceId || '',
            application?.applicationType || '',
            false,
            application?.createdAt,
            toggler
          ),
          {
            id,
            applicant1ReferenceId,
          }
        );
      } else if (checkApplication) {
        if (isSaveLater) {
          enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
            variant: 'success',
            autoHideDuration: 3000,
          });
        }
        history.push(
          navigateToNextStep(
            path,
            role,
            id || '',
            isSaveLater,
            applicant1ReferenceId || '',
            application?.applicationType || '',
            false,
            application?.createdAt,
            toggler
          ),
          {
            id,
            applicant1ReferenceId,
          }
        );
      }
    } catch (e) {
      setLoading(false);
      typeof e === 'string' && dispatch(showError(e));
      console.error((e as Error).message);
    }
  };

  return (
    <Formik
      initialValues={fatcaDetails}
      onSubmit={handleSubmit}
      validate={(values: Values) => {
        try {
          validateYupSchema(
            values,
            FATCAValidationSchema(
              application?.applicants as Partial<Applicant>[],
              application?.createdAt || '',
              toggler
            ),
            true,
            values
          );
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}
      enableReinitialize={true}>
      {({ handleSubmit, values, setValues }) => (
        <Grid
          container
          rowSpacing={1}
          // columnSpacing={5}
          sx={{
            width: '100%',
            ml: 0,
            '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
          }}
          component="form"
          noValidate
          onSubmit={handleSubmit}>
          <Notes
            displayContent={'FATCA Information is mandatory to disclose any Foreign Citizenship'}
          />
          {values.applicants.map((applicant, index) => (
            <FatcaDetails
              applicantName={getApplicantName(index + 1)}
              index={index}
              key={index}
              values={applicant}
              nationalitiesMdmsResponse={mdmsCountriesList}
              createdAt={application?.createdAt || ''}
              tinCountries={tinCountries}
              formvalues={values}
              setValues={setValues}
            />
          ))}
          <ProceedSaveLater
            saveLater={() => {
              setValues({
                ...values,
                saveType: 'save for later',
              });
            }}
            saveAndProceed={() => {
              setValues({
                ...values,
                saveType: 'save and proceed',
              });
            }}
            loader={loading}
            clickedButton={values.saveType}
          />
        </Grid>
      )}
    </Formik>
  );
}
